<div class="d-flex justify-content-center align-items-center px-3 py-5 bg-waves">
    <mat-card class="col-12 col-md-4">
        <mat-card-content>
            <div class="text-center text-muted">
                <h1 class="text-indigo fs-4 mb-1 mt-3">REMOVER CADASTRO</h1>
                <h2 class="fs-6 fw-light mb-4">Informe seus dados para solicitar a remoção</h2>
            </div>
            <form class="d-flex flex-column" name="form" (ngSubmit)="form.valid && removerCadastro(form)" #form="ngForm" novalidate>
                <!-- NOME COMPLETO -->
                <mat-form-field class="w-100 mb-2">
                    <mat-label>Nome Completo</mat-label>
                    <input matInput name="nomeCompleto" #nomeCompleto="ngModel" ngModel required>
                    <mat-error *ngIf="showInputError(nomeCompleto, 'required')">Nome completo é obrigatório</mat-error>
                </mat-form-field>

                <!-- EMAIL -->
                <mat-form-field class="w-100 mb-2">
                    <mat-label>Email</mat-label>
                    <input matInput type="email" name="email" #email="ngModel" ngModel required>
                    <mat-error *ngIf="showInputError(email, 'required')">Email é obrigatório</mat-error>
                </mat-form-field>

                <button mat-flat-button color="primary" class="btn-lg" [disabled]="form.form.invalid || loading">
                    <mat-spinner class="btn-spinner" *ngIf="loading"></mat-spinner>
                    <span *ngIf="!loading">ENVIAR</span>
                </button>
                
                <div class="text-center mt-3">
                    <button type="button" mat-button color="primary" [routerLink]="['/sign-in']">Voltar para o login</button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</div>
